var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-index"},[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"财税智能体"}}),_c('h1',[_vm._v("财税智能体")]),_c('p',[_vm._v("手机端")])]),_c('div',{staticClass:"loading-spinner"}),_c('p',{staticClass:"loading-text"},[_vm._v("正在加载...")])])])
}]

export { render, staticRenderFns }